(function () {
  function init(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-ae-step]"));
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-ae-card]"));
    var track = root.querySelector("[data-ae-track]");
    var stage = root.querySelector(".ae-days__stage");
    var prev = root.querySelectorAll("[data-ae-prev]");
    var next = root.querySelectorAll("[data-ae-next]");
    var total = cards.length;
    if (!total || !track) return;

    var index = 0;

    function shiftPx() {
      var card = cards[0];
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }

    function go(nextIndex) {
      index = (nextIndex + total) % total;
      cards.forEach(function (card, i) {
        card.classList.toggle("is-active", i === index);
      });
      steps.forEach(function (step, i) {
        var on = i === index;
        step.classList.toggle("is-active", on);
        step.setAttribute("aria-current", on ? "true" : "false");
      });
      track.style.transform = "translateX(-" + index * shiftPx() + "px)";
    }

    steps.forEach(function (step, i) {
      step.addEventListener("click", function () {
        go(i);
      });
    });
    prev.forEach(function (btn) {
      btn.addEventListener("click", function () {
        go(index - 1);
      });
    });
    next.forEach(function (btn) {
      btn.addEventListener("click", function () {
        go(index + 1);
      });
    });

    window.addEventListener("resize", function () {
      go(index);
    });

    if (window.ResizeObserver && stage) {
      new ResizeObserver(function () {
        go(index);
      }).observe(stage);
    }

    go(0);
    window.addEventListener("load", function () {
      go(index);
    });
  }

  document.querySelectorAll("[data-ae-days]").forEach(init);
})();
